<template>
  <a-dropdown placement="topRight">
    <span class="ant-dropdown-link">
      <i class="icon iconfont iconicon-test77" />
    </span>
    <a-menu slot="overlay">
      <template>
        <template v-if="projectItemData.status*1 === 1">
          <!-- 修改 -->
          <a-menu-item
            @click="editPro"
          >
            {{ $t('message["1388"]') }}
          </a-menu-item>
          <!-- 关闭 -->
          <a-menu-item @click="closePro">
            {{ $t('message["401"]') }}
          </a-menu-item>
          <pro-tip-dialog
            ref="tipDialog"
            :project-item-data="projectItemData"
            :manage-type="manageType"
            @triggerMethod="triggerEdit"
          />
          <edit-pro-dialog
            v-if="tabType !== 'realback'"
            ref="editDialog"
            :project-item-data="projectItemData"
          />
          <edit-realback-pro-dialog
            v-if="tabType === 'realback'"
            ref="editDialog"
            :project-item-data="projectItemData"
          />
        </template>
        <template v-else>
          <!-- 立即升级 -->
          <a-menu-item
            v-if="!isMember && projectItemData.remark && projectItemData.remark.usedvip*1 === 1 &&(projectItemData.vip === 0) "
            @click="serviceUp"
          >
            {{ $t('message["599"]') }}
          </a-menu-item>
          <!-- 重新打开 -->
          <a-menu-item
            v-else
            @click="openPro"
          >
            {{ $t('message["1620"]') }}
          </a-menu-item>
        </template>
      </template>
      <!-- 删除 -->
      <a-menu-item @click="delPro">
        {{ $t('message["962"]') }}
      </a-menu-item>
      <del-pro-dialog
        ref="delDialog"
        :project-item-data="projectItemData"
      />
      <service-up-tip
        v-if="!isMember"
        ref="serviceuptip"
        :project-item-data="projectItemData"
        @serviceupDia="serviceupDia"
      />
      <service-up-dia
        v-if="!isMember"
        ref="serviceupdia"
        :project-item-data="projectItemData"
      />
    </a-menu>
  </a-dropdown>
</template>

<script>
import ProTipDialog from './ProTipDialog'
import EditProDialog from './EditProDialog'
import EditRealbackProDialog from './../createPro/EditRealbackProDialog'
import DelProDialog from './DelProDialog'
import ServiceUpTip from './ServiceUpTip'
import ServiceUpDia from '@/components/pc/serviceup/ServiceUpDia'
import { mapActions } from 'vuex'
import { getStorage } from '@/lib/storage'

export default {
  components: {
    ProTipDialog,
    EditProDialog,
    EditRealbackProDialog,
    DelProDialog,
    ServiceUpTip,
    ServiceUpDia
  },
  props: {
    projectItemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      manageType: ''
    }
  },
  computed: {
    cId () {
      return this.projectItemData.cid
    },
    projectId () {
      return this.projectItemData.projectid
    },
    tabType () {
      const { type } = this.$route.query
      return type
    },
    isMember () {
      return this.$route.query.type === 'member'
    }
  },
  methods: {
    ...mapActions('organization/org', ['ajaxOpenPro', 'fetchProjectList']),
    ...mapActions('organization/orgRealback', ['ajaxOpenProRealback']),
    editPro () {
      this.manageType = 'edit'
      this.$refs.tipDialog.changeLimitDialog(true)
    },
    closePro () {
      this.manageType = 'close'
      this.$refs.tipDialog.changeLimitDialog(true)
    },
    triggerEdit () {
      this.$refs.editDialog.changeVisible(true)
    },
    delPro () {
      this.$refs.delDialog.changeVisible(true)
    },
    async openPro () {
      let chain = null
      if (this.tabType === 'realback') {
        const realbackCid = getStorage('realbackCid')
        chain = await this.ajaxOpenProRealback({
          cid2: this.cId,
          cid: realbackCid,
          projectid: this.projectId
        })
        chain.onSuccess(async () => {
          const chain2 = await this.fetchProjectList({ cid: this.cId })
          chain2.fetch()
        })
      } else {
        chain = await this.ajaxOpenPro({ cid: this.cId })
        chain
          .params({
            cid: this.cId,
            projectid: this.projectId,
            pType: this.isMember ? 2 : 1
          })
          .fetch()
      }
    },
    serviceUp () {
      this.$refs.serviceuptip.changeLimitDialog(true)
    },
    async serviceupDia () {
      this.$refs.serviceupdia.changeVisible(true)
    }
  }
}
</script>
<style lang="scss" scoped>
  .iconicon-test77 {
    font-size: 24px;
    color: #ccc;
  }
</style>
